/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {APP_SHARED} from '../app-shared';
import {ConfirmObjectStateModalComponent} from '../directives/confirm-object-state-modal.component';
import {ObjectStatesComponent} from '../directives/object-states.component';
import {ViewObjectStatesComponent} from '../directives/view-object-states.component';
import {SignalAdminResourceListComponent} from './signal-admin-resource-list.component';

export const ADMIN_RESOURCE_PAGE_IMPORTS = [
  ...APP_SHARED,
  FormsModule,
  TranslateModule,
  UIRouterModule,
  ObjectStatesComponent,
  ViewObjectStatesComponent,
  ConfirmObjectStateModalComponent,
  SignalAdminResourceListComponent
];
